{
  "_format": "hh-sol-artifact-1",
  "contractName": "MockERC20",
  "sourceName": "contracts/mocks/MockERC20.sol",
  "abi": [
    {
      "inputs": [
        {
          "internalType": "string",
          "name": "name",
          "type": "string"
        },
        {
          "internalType": "string",
          "name": "symbol",
          "type": "string"
        },
        {
          "internalType": "uint8",
          "name": "decimals_",
          "type": "uint8"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "constructor"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "owner",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "spender",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "value",
          "type": "uint256"
        }
      ],
      "name": "Approval",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "address",
          "name": "account",
          "type": "address"
        }
      ],
      "name": "Paused",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "bytes32",
          "name": "role",
          "type": "bytes32"
        },
        {
          "indexed": true,
          "internalType": "bytes32",
          "name": "previousAdminRole",
          "type": "bytes32"
        },
        {
          "indexed": true,
          "internalType": "bytes32",
          "name": "newAdminRole",
          "type": "bytes32"
        }
      ],
      "name": "RoleAdminChanged",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "bytes32",
          "name": "role",
          "type": "bytes32"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "account",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "sender",
          "type": "address"
        }
      ],
      "name": "RoleGranted",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "bytes32",
          "name": "role",
          "type": "bytes32"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "account",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "sender",
          "type": "address"
        }
      ],
      "name": "RoleRevoked",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "from",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "value",
          "type": "uint256"
        }
      ],
      "name": "Transfer",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "address",
          "name": "account",
          "type": "address"
        }
      ],
      "name": "Unpaused",
      "type": "event"
    },
    {
      "inputs": [],
      "name": "DEFAULT_ADMIN_ROLE",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "MINTER_ROLE",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "PAUSER_ROLE",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "owner",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "spender",
          "type": "address"
        }
      ],
      "name": "allowance",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "spender",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "approve",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "account",
          "type": "address"
        }
      ],
      "name": "balanceOf",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "burn",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "account",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "burnFrom",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "decimals",
      "outputs": [
        {
          "internalType": "uint8",
          "name": "",
          "type": "uint8"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "spender",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "subtractedValue",
          "type": "uint256"
        }
      ],
      "name": "decreaseAllowance",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "bytes32",
          "name": "role",
          "type": "bytes32"
        }
      ],
      "name": "getRoleAdmin",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "bytes32",
          "name": "role",
          "type": "bytes32"
        },
        {
          "internalType": "uint256",
          "name": "index",
          "type": "uint256"
        }
      ],
      "name": "getRoleMember",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "bytes32",
          "name": "role",
          "type": "bytes32"
        }
      ],
      "name": "getRoleMemberCount",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "bytes32",
          "name": "role",
          "type": "bytes32"
        },
        {
          "internalType": "address",
          "name": "account",
          "type": "address"
        }
      ],
      "name": "grantRole",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "bytes32",
          "name": "role",
          "type": "bytes32"
        },
        {
          "internalType": "address",
          "name": "account",
          "type": "address"
        }
      ],
      "name": "hasRole",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "spender",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "addedValue",
          "type": "uint256"
        }
      ],
      "name": "increaseAllowance",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "mint",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "name",
      "outputs": [
        {
          "internalType": "string",
          "name": "",
          "type": "string"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "pause",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "paused",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "bytes32",
          "name": "role",
          "type": "bytes32"
        },
        {
          "internalType": "address",
          "name": "account",
          "type": "address"
        }
      ],
      "name": "renounceRole",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "bytes32",
          "name": "role",
          "type": "bytes32"
        },
        {
          "internalType": "address",
          "name": "account",
          "type": "address"
        }
      ],
      "name": "revokeRole",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "bytes4",
          "name": "interfaceId",
          "type": "bytes4"
        }
      ],
      "name": "supportsInterface",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "symbol",
      "outputs": [
        {
          "internalType": "string",
          "name": "",
          "type": "string"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "totalSupply",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "transfer",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "from",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "transferFrom",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "unpause",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    }
  ],
  "bytecode": "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",
  "deployedBytecode": "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",
  "linkReferences": {},
  "deployedLinkReferences": {}
}
